import axios from "@/http"
export function fetchAssociationList(query) {
  return axios({
    url: '/api/v1/information/association/associations',
    method: 'get',
    params: query
  })
}
export function fetchAssociationThreadList(query) {
  return axios({
    url: '/api/v1/information/association/threads',
    method: 'get',
    params: query
  })
}

export function fetchAssociation(id) {
  return axios({
    url: '/api/v1/information/association/associations/'+id,
    method: 'get',
    params:{ id, preload:true },
  })
}

export function createAssociation(data) {
  return axios({
    url: '/api/v1/information/association/associations',
    method: 'post',
    data
  })
}

export function updateAssociation(data) {
  return axios({
    url: '/api/v1/information/association/associations/' + data.id,
    method: 'put',
    params: data.where?{where: data.where}: undefined,
    data
  })
}
export function createAssociationFollower(data) {
  return axios({
    url: '/api/v1/information/association/relation/associationfollowers',
    method: 'post',
    data
  })
}
export function deleteAssociationThread(id) {
  return axios({
    url: '/api/v1/information/association/threads/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/axj-information/axj-information-association.js